import { call } from './utils';

export const createTrail = async (data, accessToken) =>
  await call({
    url: '/api/trails/create',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
export const updateTrail = async (data, accessToken) =>
  await call({
    url: '/api/trails/update',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
export const removeTrail = async (data, accessToken) =>
  await call({
    url: '/api/trails/remove',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
export const findAllTrails = async (data, accessToken) =>
  await call({
    url: '/api/trails/find/all',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
export const findTrailById = async (data, accessToken) =>
  await call({
    url: '/api/trails/find/by/id',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
export const findTrailsByUserId = async (data, accessToken) =>
  await call({
    url: '/api/trails/find/by/user',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
export const getAllTrailsByStationId = async (data, accessToken) =>
  await call({
    url: '/api/trails/find/all/by/station/id',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
